import { useColorScheme, Stack, Button, Box } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";

export const ThemeModeToggle = ({ onClose }: { onClose?: () => void }) => {
  const { mode, setMode } = useColorScheme();
  if (!mode) {
    return null;
  }

  const changeMode = (mode: "light" | "dark") => {
    setMode(mode);
    onClose && onClose();
  };

  return (
    <Box
      sx={{
        "& span": {
          fontSize: "0.68rem",
        },
      }}
      className="theme-mode-toggle"
    >
      <Stack direction="row" spacing={1}>
        <Button
          onClick={() => changeMode("light")}
          variant={mode === "light" ? "contained" : "outlined"}
        >
          <Stack alignItems="center">
            <LightModeIcon />
            <span>Light Mode</span>
          </Stack>
        </Button>
        <Button
          onClick={() => changeMode("dark")}
          variant={mode === "dark" ? "contained" : "outlined"}
        >
          <Stack alignItems="center">
            <DarkModeIcon />
            <span>Dark Mode</span>
          </Stack>
        </Button>
      </Stack>
    </Box>
  );
};
